import Skeleton from '@mui/material/Skeleton'
import { styled } from '@mui/material/styles'
import React from 'react'

import Colors from '#/styles/Old/Colors'

const SkeletonCard = styled('div')({
  padding: '25px 20px',
  color: 'white',
  borderRadius: 4,
  backgroundColor: Colors.darkgrey,
})

const SkeletonList = styled('ul')({
  margin: 0,
  padding: 0,
  listStyleType: 'none',
})

const NestedSkeletonList = styled(SkeletonList)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}))

const SkeletonItem = styled('div')({
  marginBottom: 20,
})

const skeletonStructure = [
  [...Array(4).keys()],
  [...Array(10).keys()],
  [...Array(2).keys()],
  [...Array(6).keys()],
]

export default function DatasheetSkeleton() {
  return (
    <SkeletonCard>
      {skeletonStructure.map((items, idx) => (
        <SkeletonItem key={`skeleton-${idx}`}>
          <Skeleton height={30} animation="wave" />
          <NestedSkeletonList>
            {items.map((_, itemIdx) => (
              <Skeleton
                key={`skeleton-inside-${itemIdx}`}
                width={`${50 + Math.random() * 50}%`}
                animation="wave"
              />
            ))}
          </NestedSkeletonList>
        </SkeletonItem>
      ))}
    </SkeletonCard>
  )
}
